import { ApolloLink } from '@apollo/client'

export const apolloAuthLink = new ApolloLink((operation, forward) => {
    const token = sessionStorage.getItem('access_token')
    operation.setContext({
        headers: { Authorization: token ? `Bearer ${token}` : '' },
    })
    return forward(operation)
})
